<template>
  <transition
    enter-active-class="transition-all"
    leave-active-class="transition-all"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="errors.length > 0"
      class="bg-red-200 text-red-800 mt-2 p-4"
    >
      {{ errors[0] }}
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  }
}
</script>
